import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=40b2d482&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
import style0 from "./Tag.vue?vue&type=style&index=0&id=40b2d482&prod&lang=less"
import style1 from "./Tag.vue?vue&type=style&index=1&id=40b2d482&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b2d482",
  null
  
)

export default component.exports